export default function AuditField({ label, value }) {
    return (
      <div className="space-y-1">
        <p className="text-xs text-gray-500 font-medium">{label}</p>
        <p className="text-sm text-gray-700">{value || "—"}</p>
      </div>
    );
  }
  